import { useMemo, useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, { SelectOption, addOption } from '../../../../../utils/InputField';
import { TextCapitalize } from '../../../../../utils/TextFormatter';
import { ApiUpdateServicePackagePricing } from '../../ServiceOperation';
import { useServiceDt } from '../ServiceDetailsProvider';

// const durationOptions = [
//     { key: 1, value: '1 Month' },
//     { key: 3, value: '3 Months' },
//     { key: 6, value: '6 Months' },
//     { key: 12, value: '1 Year' },
//     { key: 24, value: '2 Years' },
//     { key: 36, value: '3 Years' },
//     { key: 48, value: '4 Years' },
//     { key: 60, value: '5 Years' }
// ];

const billingCycle = [
    { key: 1, value: 'monthly' },
    { key: 3, value: 'quarterly' },
    { key: 6, value: 'half-yearly' },
    { key: 12, value: 'yearly' }
];

function UpdatePackagePriceModal({ closeModal, handleReload, modalData }) {
    const { serviceInfo, packageInfo } = useServiceDt();
    const { setMessage } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        Id: modalData?.id,
        AppServiceId: serviceInfo?.id,
        PackageId: packageInfo?.id,
        Currency: modalData?.currency,
        // Duration: modalData?.duration,
        LimitByValue: modalData?.limitByValue,
        Amount: modalData?.amount === -101 ? 'Flexible' : modalData?.amount,
        VatPercent: modalData?.vatPercent,
        Status: modalData?.status
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const payload = useMemo(() => {
        return {
            ...formData,
            Amount: formData?.Amount === 'Flexible' ? -101 : formData?.Amount
        };
    }, [formData]);

    const handleEditCustomer = (e) => {
        setLoading(true);
        e.preventDefault();

        ApiUpdateServicePackagePricing(
            serviceInfo?.id,
            packageInfo?.id,
            modalData?.id,
            payload,
            setIsError
        )
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleEditCustomer} className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-2">
                <SelectOption
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    options={['thb', 'usd', 'eur', 'bdt']?.map((item) =>
                        addOption(item, item?.toUpperCase(), item.toUpperCase())
                    )}
                    disabled
                />
                {/* {serviceInfo?.isDuration && (
                    <SelectOption
                        label="Contract Duration"
                        name="contractDuration"
                        formData={formData}
                        onChange={handleChange}
                        options={durationOptions?.map(({ key, value }) =>
                            addOption(key, value, key)
                        )}
                    />
                )} */}
                {serviceInfo?.isDuration && (
                    <InputField
                        label="Billing Cycle"
                        name="LimitByValue"
                        formData={{
                            LimitByValue: billingCycle?.find(
                                ({ key }) => key === formData?.LimitByValue
                            )?.value
                        }}
                        onChange={handleChange}
                        disabled
                        className="capitalize"
                    />
                )}

                <InputField
                    label="Amount"
                    name="Amount"
                    placeholder="Type amount..."
                    formData={formData}
                    onChange={handleChange}
                    disabled={formData?.Amount === 'Flexible'}
                />
                <InputField
                    label="VAT %"
                    name="VatPercent"
                    placeholder="Type vat..."
                    formData={formData}
                    onChange={handleChange}
                />
                <SelectOption
                    label="Status"
                    name="Status"
                    formData={formData}
                    onChange={handleChange}
                    options={['active', 'inactive']?.map((key) =>
                        addOption(key, TextCapitalize(key), key)
                    )}
                />
            </div>
            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} onClick={null} />
            </div>
        </form>
    );
}

export default UpdatePackagePriceModal;
